export enum MessageSubjectEnum {
    SUBJECT_PRICING = 'opay_pricing',
    SUBJECT_PRICING_SHOPIFY = 'opay_pricing_shopify',
    SUBJECT_CONFERENCE = 'opay_conference'
}
